export default __webpack_public_path__ + "static/media/exclamation-solid.139a5771.svg";